import { providers } from '../../providers';
import { wavespeed } from '../wavespeed';
import type { VideoModelEntry } from '../types';

// 系数
const COST_FACTOR = 1.5;

export const skyworkModels: VideoModelEntry[] = [
    {
        id: 'skyreels-v3-standard-single-avatar',
        chef: providers.skywork,
        providers: [
            {
                ...providers.skywork,
                model: wavespeed('skyreels-v3-standard-single-avatar'),
                getCost: ({ providerOptions }) => {
                    const inputDur = providerOptions?._media?.audioDurationSeconds ?? 15;
                    return inputDur * 0.04 * COST_FACTOR;
                },
                getPassCount: ({ providerOptions }) => {
                    const inputDur = providerOptions?._media?.audioDurationSeconds ?? 15;
                    return inputDur * 0.04 * COST_FACTOR * 100;
                },
            },
        ],
        configByMode: {
            avatar: {
                aspectRatios: [],
                durations: [],
                qualities: [],
                inlineMedia: {
                    allowInline: true,
                    image: { allow: true, maxCount: 1, maxSize: '10MB', slot: true, formats: ['image/png', 'image/jpeg'] },
                    video: { allow: false, maxCount: 0, maxSize: '0' },
                    audio: { allow: true, maxCount: 1, maxSize: '10MB', slot: true, formats: ['audio/mpeg', 'audio/wav'] },
                    maxTotalCount: 2,
                },
            },
        },
        precheckByMode: {
            avatar: ['prompt', 'image', 'audio'],
        },
        supportsEdit: false,
        supportsInput: ['avatar'],
        priceIndicator: 'lowest',
        price: 'Dynamic',
    },
    {
        id: 'skyreels-v3-pro-single-avatar',
        chef: providers.skywork,
        providers: [
            {
                ...providers.skywork,
                model: wavespeed('skyreels-v3-pro-single-avatar'),
                getCost: ({ providerOptions }) => {
                    const inputDur = providerOptions?._media?.audioDurationSeconds ?? 15;
                    return inputDur * 0.08 * COST_FACTOR;
                },
                getPassCount: ({ providerOptions }) => {
                    const inputDur = providerOptions?._media?.audioDurationSeconds ?? 15;
                    return inputDur * 0.08 * COST_FACTOR * 100;
                },
            },
        ],
        configByMode: {
            avatar: {
                aspectRatios: [],
                durations: [],
                qualities: [],
                inlineMedia: {
                    allowInline: true,
                    image: { allow: true, maxCount: 1, maxSize: '10MB', slot: true, formats: ['image/png', 'image/jpeg'] },
                    video: { allow: false, maxCount: 0, maxSize: '0' },
                    audio: { allow: true, maxCount: 1, maxSize: '10MB', slot: true, formats: ['audio/mpeg', 'audio/wav'] },
                    maxTotalCount: 2,
                },
            },
        },
        precheckByMode: {
            avatar: ['prompt', 'image', 'audio'],
        },
        supportsEdit: false,
        supportsInput: ['avatar'],
        priceIndicator: 'lowest',
        price: 'Dynamic',
    },
];